// This file will be generated as a viewerScript.bundle.js

export const mapPlatformStateToAppData = async ({
  platformParams,
  controllerConfigs,
  flowData,
}: any) => {
  return { platformParams, controllerConfigs, flowData };
};

export const initAppForPage = (...args: any) => {
  console.log('INIT APP FOR PAGE', args);
};
